var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolePrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0212 3.42012C22.0212 1.53124 23.5524 0 25.4413 0C27.3302 0 28.8614 1.53124 28.8614 3.42012V46.5799C28.8614 48.4688 27.3302 50 25.4413 50C23.5524 50 22.0212 48.4688 22.0212 46.5799V3.42012Z",
    fill: "#0059B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53751 14.519C1.13608 14.519 0 13.3829 0 11.9815C0 10.58 1.13608 9.44395 2.53751 9.44395H47.4625C48.8639 9.44395 50 10.58 50 11.9815C50 13.3829 48.8639 14.519 47.4625 14.519H2.53751Z",
    fill: "#0059B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.89938C0 6.41265 1.20524 5.20741 2.69197 5.20741C4.1787 5.20741 5.38394 6.41265 5.38394 7.89938V11.827C5.38394 13.3137 4.1787 14.519 2.69197 14.519C1.20524 14.519 0 13.3137 0 11.827V7.89938Z",
    fill: "#0059B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54634 7.89938C7.54634 6.41265 8.75157 5.20741 10.2383 5.20741C11.725 5.20741 12.9303 6.41265 12.9303 7.89938V11.827C12.9303 13.3137 11.725 14.519 10.2383 14.519C8.75157 14.519 7.54634 13.3137 7.54634 11.827V7.89938Z",
    fill: "#0059B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2463 7.89938C37.2463 6.41265 38.4515 5.20741 39.9382 5.20741C41.425 5.20741 42.6302 6.41265 42.6302 7.89938V11.827C42.6302 13.3137 41.425 14.519 39.9382 14.519C38.4515 14.519 37.2463 13.3137 37.2463 11.827V7.89938Z",
    fill: "#0059B2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6161 7.89938C44.6161 6.41265 45.8213 5.20741 47.308 5.20741C48.7948 5.20741 50 6.41265 50 7.89938V11.827C50 13.3137 48.7948 14.519 47.308 14.519C45.8213 14.519 44.6161 13.3137 44.6161 11.827V7.89938Z",
    fill: "#0059B2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0555 14.2492L16.1477 13.157L23.529 20.5383L22.4368 21.6305L15.0555 14.2492Z",
    fill: "#0059B2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7423 13.1509L35.8345 14.2431L28.4532 21.6244L27.361 20.5322L34.7423 13.1509Z",
    fill: "#0059B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolePrimary);
export default __webpack_public_path__ + "static/media/pole_primary.238f858c5c251cccdc3d692a00113a43.svg";
export { ForwardRef as ReactComponent };